import { useSelector } from "react-redux";
import store from "../../stores/store";
import LayerTree from "../layerTree/LayerTree";
import { useEffect } from "react";
import SearchPanel from "../searchPanel/SearchPanel";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import CQLFilterPanel from "../cqlFilterPanel/cqlFilterPanel";
import SLDEditorPanel from "../sldEditorPanel/sldEditorPanel";
import MapGetPoints from "../map/mapGetPoints";
import MapSetPoints from "../map/mapSetPoints";
import MapSettingsPanel from "../map/mapSettingsPanel";
import SwipePanel from "../swipe/swipePanel";
import EditPanel from "../edit/editPanel";
import PrintPanel from "../print/printPanel";
import Bookmarks from "../map/bookmarks";
import GooglePanel from "../google/googlePanel";
import { trans } from "../../lib/utils";
import CSWPanel from "../cswPanel/cswPanel";
import Forms from "../forms/forms";

function LeftPanel() {
  const leftPanelActiveTab = useSelector(
    (state) => state.app.leftPanelActiveTab
  );

  useEffect(() => {}, []);

  return (
    <div
      style={{ width: "30rem", maxWidth: "30rem" }}
      className="ps-2 pe-2 d-flex "
    >
      <ul
        className="nav nav-tabs  small flex-column text-center border-end"
        style={{ width: "30px" }}
        id="left-menu"
      >
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "layers" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "layers",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-layer-group "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "search" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "search",
              });
              window["recaclulatePerfectScrollbarHeight"]();
            }}
          >
            <span className="color-black">
              <i className="fas fa-search "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "cqlFilter" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "cqlFilter",
              });
              window["recaclulatePerfectScrollbarHeight"]();
            }}
          >
            <span className="color-black">
              <i className="fas fa-filter "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "sldEditor" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "sldEditor",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-palette "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "swipe" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "swipe",
              });

              window["recaclulatePerfectScrollbarHeight"]();
            }}
          >
            <span className="color-black">
              <i className="fas fa-columns "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "mapSetPoints" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "mapSetPoints",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-map-marker-alt "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "mapGetPoints" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "mapGetPoints",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-map-marked-alt "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "mapSettings" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "mapSettings",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-cog "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "edit" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "edit",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-draw-polygon "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "print" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "print",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-print "></i>
            </span>
          </span>
        </li>

        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "bookmarks" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "bookmarks",
              });
            }}
          >
            <span className="color-black">
              <i className="far fa-bookmark "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "google" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "google",
              });
            }}
          >
            <span className="color-black">
              <i className="fab fa-google "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "cswsearch" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "cswsearch",
              });
            }}
          >
            <span className="color-black">
              <i className="fas fa-book-open "></i>
            </span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              leftPanelActiveTab === "forms" ? "active" : ""
            )}
            onClick={() => {
              window["showLeftPanel"]();
              store.dispatch({
                type: "app/leftPanelActiveTab",
                payload: "forms",
              });
            }}
          >
            <span className="color-black">
              <i className="fab fa-wpforms "></i>
            </span>
          </span>
        </li>
      </ul>
      <div
        className="tab-content ms-2 menu-offcanvas"
        id="menu-offcanvas-id"
        style={{ height: "calc(100vh -6rem)" }}
      >
        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "layers" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"layers"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Manage Layers")}
          </label>
          <LayerTree></LayerTree>
        </div>
        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "search" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"search"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Search")}
          </label>
          <SearchPanel></SearchPanel>
        </div>
        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "cqlFilter" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"cqlFilter"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("CQL Filter")}
          </label>
          <CQLFilterPanel></CQLFilterPanel>
        </div>

        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "sldEditor" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"sldEditor"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("SLD Editor")}
          </label>
          <SLDEditorPanel></SLDEditorPanel>
        </div>

        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "swipe" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"swipe"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Swipe")}
          </label>
          <SwipePanel></SwipePanel>
        </div>
        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "mapSetPoints" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"mapSetPoints"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Set Points")}
          </label>
          <MapSetPoints></MapSetPoints>
        </div>
        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "mapGetPoints" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"mapGetPoints"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Get Points")}
          </label>
          <MapGetPoints></MapGetPoints>
        </div>
        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "mapSettings" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"mapSettings"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Map Settings")}
          </label>
          <MapSettingsPanel></MapSettingsPanel>
        </div>
        <div
          className={"tab-pane  tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "edit" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"edit"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Edit")}
          </label>
          <EditPanel></EditPanel>
        </div>
        <div
          className={"tab-pane tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "print" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"print"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="fas fa-times me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Print")}
          </label>
          <PrintPanel></PrintPanel>
        </div>
        <div
          className={"tab-pane tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "bookmarks" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"bookmarks"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="far fa-bookmark me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Bookmarks")}
          </label>
          <Bookmarks></Bookmarks>
        </div>
        <div
          className={"tab-pane tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "google" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"google"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="far fa-bookmark me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Google Tools")}
          </label>
          <GooglePanel></GooglePanel>
        </div>
        <div
          className={"tab-pane tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "cswsearch" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"cswsearch"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="far fa-bookmark me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("CSW Search")}
          </label>
          <CSWPanel></CSWPanel>
        </div>
        <div
          className={"tab-pane tab-pane-menu fade  ".concat(
            leftPanelActiveTab === "forms" ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"forms"}
        >
          <label className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
            <i
              className="far fa-bookmark me-2 display-lt-md-inline-block"
              onClick={() => {
                window["hideLeftPanel"]();
              }}
              role="button"
            ></i>
            {trans("Forms")}
          </label>
          <Forms></Forms>
        </div>
      </div>
    </div>
  );
}

export default LeftPanel;
